import React from 'react'

const FlagCZ: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 600" {...rest}>
    <rect width="900" height="300" fill="#fff" />
    <rect width="900" height="300" y="300" fill="#D7141A" />
    <path d="M 0,0 L 450,300 L 0,600 z" fill="#11457E" />
  </svg>
)

export default FlagCZ 